import { Document, Packer, Paragraph, TextRun, HeadingLevel, ImageRun,TableRow, TableCell, WidthType, Table } from 'docx';
import jsPDF from 'jspdf';
import { saveAs } from 'file-saver';
import {fetchPolicyImage, fetchPolicyImageAsDataUrl, fetchPolicyImageAsArrayBuffer } from '../services/policyAPIs';

const Server_URL = process.env.REACT_APP_AXO_PEOPLE_URL;

const getAuthToken = () => {
  return localStorage.getItem('token');
};

// Helper function to process policy body for lists
// const processPolicyBody = (body) => {
//   const lines = body.split('\n');
//   const processedLines = lines.map((line, index) => {
//     const trimmed = line.trim();
//     if (trimmed.startsWith('-')) {
//       return { type: 'bullet', text: trimmed.slice(1).trim() };
//     } else if (/^\d+\./.test(trimmed)) {
//       return { type: 'numbered', text: trimmed.replace(/^\d+\./, '').trim(), number: parseInt(trimmed.match(/^\d+/)[0]) };
//     }
//     return { type: 'text', text: trimmed };
//   });
//   return processedLines;
// };

// export const generatePDF = async (title, policies) => {
//   const doc = new jsPDF();
//   let yOffset = 20;
//   const pageWidth = 210; // A4 width in mm
//   const margin = 20;
//   const maxImageWidth = 80;
//   const imageSpacing = 5;

//   // Add main title
//   doc.setFontSize(20);
//   doc.text(title, 20, yOffset);
//   yOffset += 10;

//   for (const policy of policies) {
//     // Add policy title as subtitle
//     doc.setFontSize(14);
//     doc.text(policy.title, 20, yOffset);
//     yOffset += 10;

//     // Process and add policy body
//     const processedLines = processPolicyBody(policy.body);
//     doc.setFontSize(12);
//     processedLines.forEach((line) => {
//       if (line.type === 'bullet') {
//         doc.text('•', 20, yOffset);
//         const splitText = doc.splitTextToSize(line.text, 160);
//         doc.text(splitText, 25, yOffset);
//         yOffset += splitText.length * 7 + 2;
//       } else if (line.type === 'numbered') {
//         const prefix = `${line.number}.`;
//         doc.text(prefix, 20, yOffset);
//         const splitText = doc.splitTextToSize(line.text, 160);
//         doc.text(splitText, 25, yOffset);
//         yOffset += splitText.length * 7 + 2;
//       } else {
//         const splitText = doc.splitTextToSize(line.text, 170);
//         doc.text(splitText, 20, yOffset);
//         yOffset += splitText.length * 7 + 2;
//       }
//     });
//     yOffset += 5; // Small space after body

//     // Add images if they exist
//     if (policy.imageUrls && policy.imageUrls.length > 0) {
//       let xOffset = margin;
//       let maxRowHeight = 0;
//       for (const imageUrl of policy.imageUrls) {
//         try {
//           console.log(`Attempting to load image for PDF: ${imageUrl}`);
//           const dataUrl = await fetchPolicyImageAsDataUrl(imageUrl);
          
//           // Create image element to get dimensions
//           const img = new Image();
//           await new Promise((resolve) => {
//             img.onload = resolve;
//             img.src = dataUrl;
//           });
          
//           const imgWidth = Math.min(img.width, maxImageWidth);
//           const imgHeight = (img.height / img.width) * imgWidth;

//           // Check if image fits in the current row
//           if (xOffset + imgWidth > pageWidth - margin) {
//             yOffset += maxRowHeight + imageSpacing;
//             xOffset = margin;
//             maxRowHeight = 0;
//           }

//           // Check if image fits on the current page
//           if (yOffset + imgHeight > 280) {
//             doc.addPage();
//             yOffset = 20;
//             xOffset = margin;
//             maxRowHeight = 0;
//           }

//           doc.addImage(dataUrl, 'JPEG', xOffset, yOffset, imgWidth, imgHeight);
//           xOffset += imgWidth + imageSpacing;
//           maxRowHeight = Math.max(maxRowHeight, imgHeight); 
//         } catch (error) {
//           console.error(`Failed to load image ${imageUrl} for PDF:`, error);
//           doc.setFontSize(10);
//           doc.setTextColor(255, 0, 0);
//           doc.text(`[Image not loaded: ${imageUrl}]`, 20, yOffset);
//           doc.setTextColor(0, 0, 0);
//           yOffset += 10;
//         }
//       }
//     }
//     yOffset += 5; // Reduced space after policy
//   }

//   doc.save(`${title}.pdf`);
// };


export const generatePDF = async (title, policies) => {
  const doc = new jsPDF();
  let yOffset = 20;
  const pageWidth = 210; // A4 width in mm
  const pageHeight = 297; // A4 height in mm
  const margin = 20;
  const maxImageWidth = 80;
  const imageSpacing = 5;
  const lineHeight = 7;
  const bottomMargin = 20; // Space to leave at bottom of page

  // Helper function to check if we need a new page
  const checkPageBreak = (requiredSpace = 10) => {
    if (yOffset + requiredSpace > pageHeight - bottomMargin) {
      doc.addPage();
      yOffset = 20;
      return true;
    }
    return false;
  };

  // Add main title
  doc.setFontSize(20);
  doc.setFont("helvetica", "bold");
  checkPageBreak(15);
  doc.text(title, margin, yOffset);
  yOffset += 15;

  for (const policy of policies) {
    // Check if we need space for policy title
    checkPageBreak(15);
    
    // Add policy title as subtitle
    doc.setFontSize(16);
    doc.setFont("helvetica", "bold");
    doc.text(policy.title, margin, yOffset);
    yOffset += 12;

    // Process and add policy body
    const processedLines = processPolicyBody(policy.body);
    doc.setFontSize(11);
    doc.setFont("helvetica", "normal");
    
    processedLines.forEach((line) => {
      if (line.type === 'bullet') {
        // Check space for bullet point
        const splitText = doc.splitTextToSize(line.text, pageWidth - margin * 2 - 10);
        const requiredSpace = splitText.length * lineHeight + 3;
        checkPageBreak(requiredSpace);
        
        doc.text('•', margin, yOffset);
        doc.text(splitText, margin + 8, yOffset);
        yOffset += splitText.length * lineHeight + 3;
        
      } else if (line.type === 'numbered') {
        const prefix = `${line.number}.`;
        const splitText = doc.splitTextToSize(line.text, pageWidth - margin * 2 - 15);
        const requiredSpace = splitText.length * lineHeight + 3;
        checkPageBreak(requiredSpace);
        
        doc.text(prefix, margin, yOffset);
        doc.text(splitText, margin + 12, yOffset);
        yOffset += splitText.length * lineHeight + 3;
        
      } else {
        const splitText = doc.splitTextToSize(line.text, pageWidth - margin * 2);
        const requiredSpace = splitText.length * lineHeight + 3;
        checkPageBreak(requiredSpace);
        
        doc.text(splitText, margin, yOffset);
        yOffset += splitText.length * lineHeight + 3;
      }
    });
    
    yOffset += 8; // Space after policy body

    // Add images if they exist
    if (policy.imageUrls && policy.imageUrls.length > 0) {
      let xOffset = margin;
      let maxRowHeight = 0;
      let imagesInCurrentRow = 0;
      const maxImagesPerRow = Math.floor((pageWidth - margin * 2) / (maxImageWidth + imageSpacing));
      
      for (const imageUrl of policy.imageUrls) {
        try {
          console.log(`Attempting to load image for PDF: ${imageUrl}`);
          const dataUrl = await fetchPolicyImageAsDataUrl(imageUrl);
          
          // Create image element to get dimensions
          const img = new Image();
          await new Promise((resolve, reject) => {
            img.onload = resolve;
            img.onerror = reject;
            img.src = dataUrl;
          });
          
          // Calculate image dimensions
          let imgWidth = Math.min(img.width * 0.75, maxImageWidth); // Scale down for better fit
          let imgHeight = (img.height / img.width) * imgWidth;
          
          // Limit height to prevent overly tall images
          const maxImageHeight = 60;
          if (imgHeight > maxImageHeight) {
            imgHeight = maxImageHeight;
            imgWidth = (img.width / img.height) * imgHeight;
          }

          // Check if we need to start a new row
          if (imagesInCurrentRow >= maxImagesPerRow || xOffset + imgWidth > pageWidth - margin) {
            yOffset += maxRowHeight + imageSpacing;
            xOffset = margin;
            maxRowHeight = 0;
            imagesInCurrentRow = 0;
          }

          // Check if image fits on current page
          if (yOffset + imgHeight > pageHeight - bottomMargin) {
            doc.addPage();
            yOffset = 20;
            xOffset = margin;
            maxRowHeight = 0;
            imagesInCurrentRow = 0;
          }

          doc.addImage(dataUrl, 'JPEG', xOffset, yOffset, imgWidth, imgHeight);
          xOffset += imgWidth + imageSpacing;
          maxRowHeight = Math.max(maxRowHeight, imgHeight);
          imagesInCurrentRow++;
          
        } catch (error) {
          console.error(`Failed to load image ${imageUrl} for PDF:`, error);
          
          // Add error message with proper page break check
          checkPageBreak(12);
          doc.setFontSize(9);
          doc.setTextColor(255, 0, 0);
          doc.text(`[Image failed to load: ${imageUrl}]`, margin, yOffset);
          doc.setTextColor(0, 0, 0);
          yOffset += 12;
        }
      }
      
      // Move yOffset past the last row of images
      if (maxRowHeight > 0) {
        yOffset += maxRowHeight;
      }
    }
    
    yOffset += 15; // Space between policies
  }

  // Add page numbers
  const totalPages = doc.internal.getNumberOfPages();
  for (let i = 1; i <= totalPages; i++) {
    doc.setPage(i);
    doc.setFontSize(8);
    doc.setFont("helvetica", "normal");
    doc.setTextColor(128, 128, 128);
    doc.text(`Page ${i} of ${totalPages}`, pageWidth - margin, pageHeight - 10, { align: 'right' });
  }

  doc.save(`${title}.pdf`);
};

// Helper function to better handle policy body processing
const processPolicyBody = (body) => {
  if (!body) return [];
  
  const lines = body.split('\n').filter(line => line.trim() !== '');
  const processedLines = [];
  
  lines.forEach((line, index) => {
    const trimmedLine = line.trim();
    
    // Check for bullet points (• or *)
    if (trimmedLine.startsWith('•') || trimmedLine.startsWith('*')) {
      processedLines.push({
        type: 'bullet',
        text: trimmedLine.substring(1).trim()
      });
    }
    // Check for numbered items (1. 2. etc.)
    else if (/^\d+\./.test(trimmedLine)) {
      const match = trimmedLine.match(/^(\d+)\.\s*(.*)$/);
      if (match) {
        processedLines.push({
          type: 'numbered',
          number: match[1],
          text: match[2]
        });
      } else {
        processedLines.push({
          type: 'text',
          text: trimmedLine
        });
      }
    }
    // Regular text
    else {
      processedLines.push({
        type: 'text',
        text: trimmedLine
      });
    }
  });
  
  return processedLines;
};


export const generateWordDoc = async (title, policies) => {
  // Pre-fetch all images to handle async properly
  const imagePromises = policies.flatMap((policy) =>
    (policy.imageUrls || []).map(async (imageUrl) => {
      try {
        const arrayBuffer = await fetchPolicyImageAsArrayBuffer(imageUrl);
        return { imageUrl, arrayBuffer };
      } catch (error) {
        console.error(`Pre-fetch failed for ${imageUrl}:`, error);
        return { imageUrl, error };
      }
    })
  );
  const imageResults = await Promise.all(imagePromises);

  const doc = new Document({
    sections: [
      {
        properties: {},
        children: [
          // Main title
          new Paragraph({
            text: title,
            heading: HeadingLevel.HEADING_1,
            spacing: { after: 200 },
          }),
          // Policies
          ...policies.flatMap((policy) => {
            const children = [
              // Policy title
              new Paragraph({
                text: policy.title,
                heading: HeadingLevel.HEADING_2,
                spacing: { after: 100 },
              }),
            ];

            // Process and add policy body
            const processedLines = processPolicyBody(policy.body);
            processedLines.forEach((line) => {
              if (line.type === 'bullet') {
                children.push(
                  new Paragraph({
                    children: [new TextRun(line.text)],
                    bullet: { level: 0 },
                    spacing: { after: 100 },
                  })
                );
              } else if (line.type === 'numbered') {
                children.push(
                  new Paragraph({
                    children: [new TextRun(line.text)],
                    numbering: {
                      reference: 'policy-numbering',
                      level: 0,
                    },
                    spacing: { after: 100 },
                  })
                );
              } else {
                children.push(
                  new Paragraph({
                    children: [new TextRun(line.text)],
                    spacing: { after: 100 },
                  })
                );
              }
            });

            // Add images if they exist
            if (policy.imageUrls && policy.imageUrls.length > 0) {
              const imageCells = policy.imageUrls.map((imageUrl) => {
                const imageResult = imageResults.find((result) => result.imageUrl === imageUrl);
                if (imageResult && imageResult.arrayBuffer) {
                  try {
                    return new TableCell({
                      children: [
                        new Paragraph({
                          children: [
                            new ImageRun({
                              data: imageResult.arrayBuffer,
                              transformation: {
                                width: 300, // Smaller width for side-by-side
                                height: 200,
                              },
                            }),
                          ],
                        }),
                      ],
                      margins: { left: 100, right: 100 },
                    });
                  } catch (error) {
                    console.error(`Failed to add image ${imageUrl} to Word table:`, error);
                    return new TableCell({
                      children: [
                        new Paragraph({
                          children: [
                            new TextRun({
                              text: `[Cannot display image: ${imageUrl}]`,
                              italics: true,
                              color: 'FF0000',
                            }),
                          ],
                        }),
                      ],
                    });
                  }
                } else {
                  console.error(`No valid image data for ${imageUrl}`);
                  return new TableCell({
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: `[Cannot display image: ${imageUrl}]`,
                            italics: true,
                            color: 'FF0000',
                          }),
                        ],
                      }),
                    ],
                  });
                }
              });

              children.push(
                new Table({
                  rows: [
                    new TableRow({
                      children: imageCells,
                    }),
                  ],
                  width: {
                    size: 100,
                    type: WidthType.PERCENTAGE,
                  },
                  margins: { left: 100, right: 100 },
                })
              );
              children.push(
                new Paragraph({
                  text: '', // Empty paragraph for spacing
                  spacing: { after: 100 },
                })
              );
            }

            return children;
          }),
        ],
      },
    ],
    numbering: {
      config: [
        {
          reference: 'policy-numbering',
          levels: [
            {
              level: 0,
              format: 'decimal',
              text: '%1.',
              alignment: 'left',
              style: { paragraph: { indent: { left: 720 } } },
            },
          ],
        },
      ],
    },
  });

  try {
    const blob = await Packer.toBlob(doc);
    saveAs(blob, `${title}.docx`);
  } catch (error) {
    console.error('Failed to generate Word document:', error);
    throw error;
  }
};
